import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Gift } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { api, formatApiError } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

export const NotifyPrefs = () => {
  const { t } = useI18n();
  const [on, setOn] = useState(null);
  useEffect(() => { api.get("/me/prefs").then((r) => setOn(r.data.notify_bonus)).catch(() => setOn(true)); }, []);
  const toggle = async (v) => {
    setOn(v);
    try {
      await api.patch("/me/prefs", { notify_bonus: v });
      toast.success(t("pref.saved"));
    } catch (e) { setOn(!v); toast.error(formatApiError(e)); }
  };
  return (
    <div className="cx-card rounded-2xl p-6 flex items-start gap-4" data-testid="notify-prefs">
      <Gift className="w-5 h-5 text-[#ffc94d] mt-0.5 shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="font-display text-white">{t("pref.bonus_title")}</div>
        <p className="text-sm text-slate-400 mt-1">{t("pref.bonus_desc")}</p>
      </div>
      <Switch checked={!!on} disabled={on === null} onCheckedChange={toggle} data-testid="notify-bonus-switch" />
    </div>
  );
};
